import type { Notice } from './notices'

/**
 * The BUILD-STATE notices the app ships in its bundle.
 *
 * ── THIS LIST IS NOW ONLY FOR WARNINGS ABOUT THE BUILD ──────────────────────
 *
 * It briefly held the Brand Change FAQ announcement too, because on 12 Sep
 * there was nowhere else to put it. There is now: 057 made notices content,
 * written by comms, with an audience, an end date, a locale and a dismissal
 * recorded per person. **Company messages go there. Nothing in this file.**
 *
 * The test is not "is it important", it is WHO IT IS ABOUT. A notice saying the
 * countdown is invented describes this build: it has no audience, no expiry,
 * and no business being editable by Comms, and it should disappear on the
 * commit that makes the countdown real rather than when somebody remembers to
 * revoke a promotion. A notice about the rebrand is about the company.
 *
 * Adding a company announcement here would put copy in front of ~900 people
 * that Comms cannot edit without a deploy and cannot aim at anybody — which is
 * exactly what FED-27 was filed about.
 *
 * ── BUMP THE VERSION WHEN YOU EDIT A BODY ───────────────────────────────────
 *
 * A dismissal is stored against a version, so editing the text of a notice
 * somebody has already waved away reaches nobody unless the number moves. That
 * is the single rule keeping a dismissible placeholder warning from recreating
 * OPS-13, where a prototype was read as the build for three days.
 */
export const HUB_NOTICES: Notice[] = [
  /* EMPTY SINCE 21 Sep, DELIBERATELY. The last entry here was the OPS-13
     guard, `placeholder-scope` (v4): "the posts are demo rows by the build
     team rather than launch copy". That sentence was written about DEV and
     shipped to PROD with the cut-over the same evening — where there are no
     demo rows, no posts at all, and the notice was describing data that does
     not exist to the first person who signed in (David, 21 Sep). A build-state
     warning that is false on the build it ships with is standing rule 4's
     worst shape, and the not-prod strip (OPS-46) now carries the one
     build-state fact that IS true per environment. Removed rather than
     re-versioned: nothing left here is about the build.

     The array stays, and stays typed, so a future build-state warning has a
     home and Home.tsx's `<Notices notices={HUB_NOTICES}>` keeps rendering an
     empty list rather than losing its call site. Company messages still do
     NOT go here — see the header. */
]
